import { getData, postData } from "../apiClient";

const ItemName = "CustomerRefund";
const API_URL = "customer-refund";

/**
 * Get paginated list of customers with available balance > 0
 * @param {{ page, limit, search }} params
 * @param {AbortSignal|null} signal
 */
export const GetAll = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
      sort: "ledger_id",
      order: "DESC",
    });
    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return { success: true, ...result };
  } catch (error) {
    console.error(`Get ${ItemName} list API error:`, error);
    return { success: false, ...error };
  }
};

export const GetAllHistory = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
      sort: "refund_id",
      order: "DESC",
    });
    const result = await getData(
      `/${API_URL}/history/?${queryParams}`,
      {},
      {},
      signal,
    );
    return { success: true, ...result };
  } catch (error) {
    console.error(`Get ${ItemName} list API error:`, error);
    return { success: false, ...error };
  }
};

export const GetAllBookingPaymentHistory = async (
  {
    page = 1,
    limit = 10,
    search = "",

    year = "",
    month = "",

    start_date = "",
    end_date = "",

    payment_method = "",
    payment_type = "",

    booking_status = "",

    sort = "payment_id",
    order = "DESC",
  },
  signal = null,
) => {
  try {
    const params = new URLSearchParams();

    // =====================================================
    // PAGINATION
    // =====================================================

    params.set("page", String(page));
    params.set("limit", String(limit));

    // =====================================================
    // SORT
    // =====================================================

    params.set("sort", sort);
    params.set("order", order);

    // =====================================================
    // SEARCH
    // =====================================================

    if (search?.trim()) {
      params.set("search", search.trim());
    }

    // =====================================================
    // PAYMENT METHOD
    // =====================================================

    if (payment_method) {
      params.set("payment_method", String(payment_method));
    }

    // =====================================================
    // PAYMENT TYPE
    // =====================================================

    if (payment_type) {
      params.set("payment_type", String(payment_type));
    }

    if (booking_status) {
      params.set("booking_status", String(booking_status));
    }

    // =====================================================
    // DATE FILTER
    //
    // RANGE HAS FIRST PRIORITY
    // =====================================================

    if (start_date) {
      params.set("start_date", String(start_date));

      if (end_date) {
        params.set("end_date", String(end_date));
      }
    }

    // =====================================================
    // MONTH
    // =====================================================
    else if (year && month) {
      params.set("year", String(year));

      params.set("month", String(month));
    }

    // =====================================================
    // YEAR
    // =====================================================
    else if (year) {
      params.set("year", String(year));
    }

    // =====================================================
    // FINAL URL
    // =====================================================

    const url = `/${API_URL}/payment/history/?${params.toString()}`;


    const result = await getData(url, {}, {}, signal);

    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} list API error:`, error);

    return {
      success: false,
      ...error,
    };
  }
};

/**
 * Get a single customer with their current ledger balance
 * @param {number|string} id - customer_id
 */
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return { data: { success: true, ...result } };
  } catch (error) {
    console.error(`Get ${ItemName} by ID API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

/**
 * Fetch active payment methods for the refund modal dropdown
 */
export const GetPaymentMethods = async () => {
  try {
    const result = await getData(`/${API_URL}/payment-methods`);
    return { data: { success: true, ...result } };
  } catch (error) {
    console.error(`Get Payment Methods API error:`, error);
    return { data: { success: false, error: error.message } };
  }
};

/**
 * Submit a refund for a customer
 * @param {{ data: { customer_id, amount, payment_method_id?, transaction_id?, remarks? } }} payload
 */
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data);
    return { data: { success: true, data: result } };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error?.data?.error || error.message
            : error.message,
        status: error.status,
      },
    };
  }
};

/**
 * Get refund history for a specific customer
 * @param {number|string} id - customer_id
 */
export const GetHistory = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}/history`);
    return { data: { success: true, ...result } };
  } catch (error) {
    return { data: { success: false, error: error.message } };
  }
};

export const getAllPaymentMethods = async () => {
  try {
    const result = await getData(`/${API_URL}/payment-methods`);
    return {
      data: {
        success: true,
        ...result,
      },
    };

  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
